module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/mastercard-b3a0a3e06ff540b088c794922f402a91.svg";